module.exports = __webpack_public_path__ + "static/story5-01-3815x1355-5c6e98b7dea2e331524297c6a30b891d.jpg";